import BaseLayout from '../../components/base-layout';
import { LoginProvider } from './context/login-context';
import { LoginComponent } from './login-component';

export function LoginFactory() {
    return (
        <BaseLayout>
            <LoginProvider>
                <LoginComponent />
            </LoginProvider>
        </BaseLayout>
    );
}
